import { dispatch } from "../../state/store";
import { setAppTypesGroups } from "../../state/ducks";
import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_API_URL;

const getRequestData = async (endpoint) => {
  return `${apiUrl}/app-type-management/${endpoint}`;
};

const fetchAppTypes = async () => {
  const url = await getRequestData("get-app-types");

  const data = await httpClient.get(url);

  if (data?.data) {
    dispatch(setAppTypesGroups(data?.data));
  }
};

const appTypesService = { fetchAppTypes };

export default appTypesService;
